const value = {
    integer: 'Введите целое число',
    validationError: 'Ошибка валидации',
    unknownError: 'Неизвестная ошибка',
    notMoreThanSymbols: 'Не более {{number}} символов',
  };

export default value;
